import React from 'react'
import { translations } from '../data/translations'

const Search = ({ searchTerm, setSearchTerm, language }) => {
  const t = translations[language]

  return (
    <div className="search-container">
      <div className="search-input-wrapper">
        <input
          type="text"
          placeholder={t.searchPlaceholder}
          value={searchTerm}
          onChange={(event) => setSearchTerm(event.target.value)}
          aria-label={t.searchPlaceholder}
        />
        {searchTerm && (
          <button
            className="search-clear"
            onClick={() => setSearchTerm('')}
            aria-label="Clear search"
            type="button"
          >
            ?
          </button>
        )}
      </div>
    </div>
  )
}

export default Search
